import React, { Component, Fragment } from 'react'
import { injectIntl, intlShape, FormattedMessage } from 'react-intl'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import { CSSTransition } from 'react-css-transition'
import { createBooking } from '../actions/bookingActions'
import Button from '../components/Button'
import FormattedCheckbox from '../components/FormattedCheckbox'
import TransitionStyles from '../lib/transitionStyles'
import BookingBreadcrumb from '../components/BookingBreadcrumb'
import Spinner from '../components/Spinner'
import { fetchParticipants } from '../lib/booking'



class BookingParticipantsPage extends Component {

  constructor(props) {
    super(props)
    this.state = {
      booking: props.booking,
      participants: null
    }
    this.keyCount = 0
    this.getKey = this.getKey.bind(this)    
    this.updateBooking = this.updateBooking.bind(this)
  }

  async componentDidMount() {
    const { props } = this
    try {
      const participants = await fetchParticipants()
      if (participants.length === 0) {
        props.history.push('/bookings/when')
      } else {
        this.setState({ participants })
      }
    } catch (e) {
      // Do nothing
    }    
  }

  getKey() {
    this.keyCount += 1
    return this.keyCount
  }

  participants = () => {
    const {participants, booking} = this.state
    if (!participants) {
      return (
        <div className="text-center">
          <Spinner />
        </div>
      )
    }

    return participants.map(participant => {
      console.log({participant, 'booking.people': booking.people})
      const checked = booking.people.find(p => p.participantId === participant.id)
      const { membership } = participant
      return (
        <button
          onClick={() => this.toggleParticipantOnBooking(participant)}
          type="button"
          className="flex border-b py-4 w-full text-left items-center"
          key={this.getKey()}
        >
          <div className="flex-grow">
            <h5 className="text-sky uppercase">
              <FormattedMessage id={`passTypes.${membership.type}`} defaultMessage="PassType" />
            ,&nbsp;
              <FormattedMessage id={`passTypes.${membership.ageCategory || 'adult'}`} defaultMessage={membership.ageCategory || 'adult'} />
            </h5>
            <h2 className="m-0">
              {`${participant.firstName} ${participant.lastName}`}
            </h2>
          </div>
          <div>
            <FormattedCheckbox checked={!!checked} />
          </div>
        </button>
      )
    })
  }

  participantAsPerson = participant => ({
    participantId: participant.id,
    firstName: participant.firstName,
    lastName: participant.lastName,
    ageCategory: (participant.membership && participant.membership.ageCategory),
    membership: participant.membership
  })

  toggleParticipantOnBooking(participant) {
    const { booking } = this.state

    const booker = booking.people.find(p => p.isBooker)
    const participants = booking.people.filter(p => p.participantId)
    const anonymous = booking.people.filter(p => !p.isBooker && !p.participantId)

    const alreadyAddedIndex = participants.findIndex(p => p.participantId === participant.id)
    if (alreadyAddedIndex !== -1) {
      participants.splice(alreadyAddedIndex, 1)
      const participantsAdults = participants.filter(p => p.ageCategory === 'adult')
      const participantsKids = participants.filter(p => p.ageCategory === 'child')
      if ((participant.membership.ageCategory === 'adult' && participantsAdults.length < booking.amountPeople)
        || (participant.membership.ageCategory === 'child' && participantsKids.length < booking.amountPeopleKids)
      ) {
        anonymous.push({
          ageCategory: participant.membership.ageCategory,
          passType: participant.membership.passType 
        })
      }
    } else {
      const personToAdd = this.participantAsPerson(participant)
      participants.push(personToAdd)

      const indexToRemove = anonymous.findIndex(a => a.ageCategory === personToAdd.ageCategory)
      if (indexToRemove !== -1) anonymous.splice(indexToRemove, 1)
    }

    booking.people = [
      ...(booker ? [booker] : []), 
      ...participants,
      ...anonymous
    ]
    this.setState({ booking })
  }

  updateBooking(e) {
    e.preventDefault()
    const {props, state} = this
    const {booking} = state
    // booking.amountPeople = booking.people.length
    props.createBooking(booking)
    props.history.push('/bookings/when')
  }

  render() {
    const { props } = this
    const { booking } = this.state

    return (
      <Fragment>
        <BookingBreadcrumb booking={booking} step={2} />

        <div className="container mx-auto md:w-2/3 lg:w-1/2 mt-10 p-2 md:p-0">
          <CSSTransition {...TransitionStyles} transitionAppear active>
            <Fragment>
              <h5 className="text-harbor-80 uppercase text-sky tracking-wide-2xl">
                <FormattedMessage
                  id="booking.participants.category"
                  defaultMessage="New booking"
                />
              </h5>
              <h1 className="border-b pb-8 text-4xl">
                <FormattedMessage
                  id="booking.participants.header"
                  defaultMessage="Will anyone be joining you down the slope?"
                />
              </h1>
              <h4 className="text-sky text-center my-8">
                <FormattedMessage
                  id="booking.participants.description"
                  defaultMessage="Select the people you wish to book for."
                />                
              </h4>
              <div>
                {this.participants()}
              </div>
              <div className="flex mt-8">
                <div className="flex-grow">
                  <Button
                    onClick={() => { props.history.goBack() }}
                    bgCss="bg-grey"
                  >
                    <FormattedMessage id='back' defaultMessage='Back' />
                  </Button>
                </div>
                <Button
                  onClick={this.updateBooking}
                >
                  <FormattedMessage id='booking.participants.submit' defaultMessage='Continue' />
                </Button>
              </div>
            </Fragment>
          </CSSTransition>
        </div>
      </Fragment>
    )
  }
}

BookingParticipantsPage.propTypes = {
  booking: PropTypes.shape({ booking: PropTypes.object }),
  intl: intlShape.isRequired
}

BookingParticipantsPage.defaultProps = {
  booking: null
}

const mapStateToProps = state => ({
  booking: state.booking
})

export default connect(mapStateToProps, { createBooking })(injectIntl(BookingParticipantsPage))